import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchCompanyUsers({ payload }) {
  try {
    const res = yield call(API.fetchCompanyUsers, payload);
    const { data } = res;
    yield put(actions.fetchCompanyUsersSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyUsersFailure(err?.response?.data));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* companyUserSaga() {
  yield takeLatest(actions.fetchCompanyUsers.type, handleFetchCompanyUsers);
}
